import React, { useEffect } from 'react';
import queryString from 'query-string';

// reactstrap components
import { Card, CardBody, Row, Col, Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

// views
import Identificacao from "../../../views/Shared/Gerador/Identificacao";
import CaracterizacaoResiduos from "../../../views/Shared/Gerador/CaracterizacaoResiduos";
import LocaisArmazenagem from "../../../views/Shared/Gerador/LocaisArmazenagem";
import LocaisColeta from '../../../views/Shared/Gerador/LocaisColeta';
import Documentos from "../../../views/Shared/Documentos";
import Declaracao from "../../../views/Shared/Declaracao";
import RequerimentoAvisoCard from '../components/RequerimentoAvisoCard';

//Context
import { useAuth } from '../../../context/auth';

export default function GeradorRSSRequerimentoNovoCadastro({ history }) {
    const { session, setupSistema } = useAuth();

    const [requerimento, set_requerimento] = React.useState(null);

    let _classificacaoGG = ["EGRS 1", "EGRS 2", "EGRS 3", "EGRS 4", "EGRS 5", "EGRS 6"]

    const steps = ['Identificação', 'Caracterização dos Resíduos', 'Armazenagem dos Resíduos', 'Pontos de Coleta', 'Documentação'];
    const [step, set_step] = React.useState(0);

    const [opcao, set_opcao] = React.useState(Object);

    const handleProximoStep = (_requerimento) => {
        if (step == 6) {
            history.push("opcoes");
        }
        else {
            set_requerimento(_requerimento);
            if (step == 2 && _classificacaoGG.filter(f => f == _requerimento.requerimentoGerador[0].classificacaoEstabelecimento.codigo).length == 0)
                set_step(step + 2);
            else
                set_step(step + 1);
        }
    }
    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        if (step == 4 && _classificacaoGG.filter(f => f == _requerimento.requerimentoGerador[0].classificacaoEstabelecimento.codigo).length == 0)
            set_step(step - 2);
        else
            set_step(step - 1);
    }

    useEffect(() => {
        let urls = history.location.search;
        let params = queryString.parse(urls);
        if (params != null && params.protocolo != null) {
            api_GET('requerimento/ByNumeroProtocolo/' + params.protocolo)
                .then(result => {
                    set_opcao({
                        tipoCadastro: "Requerimento",
                        segmento: "Grande Gerador",
                        categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                    });
                    set_requerimento(result.data);
                    if (result.data.status == "Divergente")
                        set_step(0);
                    else if (result.data.etapaCadastro != null) {
                        if (result.data.etapaCadastro == 3 && _classificacaoGG.filter(f => f == result.data.requerimentoGerador[0].classificacaoEstabelecimento.codigo).length == 0)
                            set_step(4);
                        else
                            set_step(result.data.etapaCadastro);
                    }
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
        }
    }, []);

    return (
        <>
            {requerimento != null && step < 6 &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor.length > 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <h5 className="text-danger">Seu requerimento foi rejeitado por {setupSistema?.identificacao}. Verifique as informações abaixo e corrija os dados necessários.</h5>
                                <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                            </CardBody>
                        </Card>
                    }

                    {step == 0 && <>
                        <RequerimentoAvisoCard />
                        <Identificacao item={requerimento} opcao={opcao} handleProximoStep={handleProximoStep}></Identificacao>
                    </>}
                    {step == 1 && <CaracterizacaoResiduos item={requerimento} tipoCadastro="Requerimento" handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></CaracterizacaoResiduos>}
                    {step == 2 && <LocaisArmazenagem item={requerimento} tipoCadastro="Requerimento" handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></LocaisArmazenagem>}
                    {step == 3 && <LocaisColeta item={requerimento} tipoCadastro="Requerimento" handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></LocaisColeta>}
                    {step == 4 && <Documentos item={requerimento} opcao={opcao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>}
                    {step == 5 && <Declaracao item={requerimento} handleFinalizarCadastro={handleProximoStep} handleStepAnterior={handleStepAnterior}></Declaracao>}
                </div>
            }

            {requerimento != null && step == 6 &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}